import axios from 'axios'
import md5 from 'js-md5'
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'


// 定义缓存池用来缓存数据
const cache = {}
const EXPIRE_TIME = 20000

const CancelToken = axios.CancelToken
// create an axios instance
const streamer = axios.create({
  // baseURL: 'http://192.168.1.61:8984', // url = base url + request url
  baseURL: 'https://danmuadmin.wokfoy.com', // url = base url + request url
  // baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_API : 'http://ubuntu:8081', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  withCredentials: false,
})

const viewer = axios.create({
  baseURL: 'https://danmuserver.wokfoy.com', // url = base url + request url
  // baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_API : 'http://ubuntu:8081', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  withCredentials: false,
})

const shop = axios.create({
  // baseURL: 'http://192.168.1.61:8980', // url = base url + request url
  baseURL: 'https://biadmin.wokfoy.com', // url = base url + request url
  // baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_API : 'http://ubuntu:8081', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  withCredentials: false,
})

const promotion = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://streamer.wokfoy.com' : 'http://127.0.0.1:3111',
  timeout: 60000,
  withCredentials: false,
})


// request interceptor
streamer.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.cache) {
      const source = CancelToken.source()
      config.cancelToken = source.token
      // 去缓存池获取缓存数据
      const key =
        config.method +
        config.baseURL +
        config.url +
        JSON.stringify(config.params)
      const data = cache[md5(key)]
      // 获取当前时间戳
      const expire_time = getExpireTime()
      if (data && expire_time - data.expire < EXPIRE_TIME) {
        source.cancel(data)
      }
    }
    // localStorage.removeItem('lvtu_live_apitoken')
    // removeToken()
    let token = store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    // do something with request error
    // for debug
    return Promise.reject(error)
  }
)

// response interceptor
streamer.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      console.log(this)
      Vue.prototype.$notify({
       title: 'ERROR',
        message: res.message || 'Error',
        type: 'error',
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  async error => {
    // 1) 被我们用 cancelToken 命中缓存的情况
    if (axios.isCancel(error)) return Promise.resolve(error.message || error);

    // 2) 真正的网络层错误（CORS/证书/超时/DNS 等），没有 response
    if (!error.response) {
      // 常见触发：预检失败、HTTPS 页面请求 HTTP、证书异常、超时
      console.error('[Axios] Network-level error:', {
        message: error.message,
        config: { method: error.config?.method, url: (error.config?.baseURL || '') + (error.config?.url || '') },
        timeout: error.config?.timeout,
      });
      return Promise.reject(new Error('Network Error（可能是 CORS/证书/超时/网络）'));
    }

    // 3) 有 response 的话，按你的业务格式处理
    const { status, data, headers } = error.response;
    // 处理HTTP状态码
    if (status == 401) {
      Vue.prototype.$notify({
        title: 'ERROR',
        message: data.message || 'Error',
        type: 'error',
      })
      // token过期处理
      if (router.currentRoute.path !== '/signin') {
        try {
          await router.replace({
            path: '/signin',
            query: { redirect: router.currentRoute.fullPath }
          });
        } catch (navErr) {
          // 忽略重复导航等
          if (!(router.isNavigationFailure?.(navErr, 16))) {
            console.warn('router replace failed:', navErr);
          }
        }
      }
      // ✅ 关键：这里“结束链路”，不要再 reject
      return Promise.reject(error); // 或 return; 让调用方的 .then/.catch 不再收到错误
    }
    // 处理其他业务错误
    if (data && data.code !== 200 && data.code !== 0) {
      const errorMsg = data.message || 'Request failed'
      Vue.prototype.$notify({
        type:'error',
        title: 'ERROR',
        message: errorMsg
      })
      return Promise.reject(new Error(errorMsg))
    }
    console.error('[Axios] HTTP error:', status, (error.config?.url || ''), headers, data);

    // 兼容 data 为空的情况
    const msg = (data && (data.message || data.msg)) || `HTTP ${status}`;
    return Promise.reject(new Error(msg));
  }
)
viewer.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.cache) {
      const source = CancelToken.source()
      config.cancelToken = source.token
      // 去缓存池获取缓存数据
      const key =
        config.method +
        config.baseURL +
        config.url +
        JSON.stringify(config.params)
      const data = cache[md5(key)]
      // 获取当前时间戳
      const expire_time = getExpireTime()
      if (data && expire_time - data.expire < EXPIRE_TIME) {
        source.cancel(data)
      }
    }
    let token = store.getters.token || localStorage.getItem('lvtu_view_apitoken') || getToken()
    console.log(token)
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    // do something with request error
    // for debug
    return Promise.reject(error)
  }
)

// response interceptor
viewer.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      // Vue.prototype.$notify({
      //   title: 'ERROR',
      //   message: res.message || 'Error',
      //   type: 'warning',
      // })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
   async error => {
    // 1) 被我们用 cancelToken 命中缓存的情况
    if (axios.isCancel(error)) return Promise.resolve(error.message || error);

    // 2) 真正的网络层错误（CORS/证书/超时/DNS 等），没有 response
    if (!error.response) {
      // 常见触发：预检失败、HTTPS 页面请求 HTTP、证书异常、超时
      console.error('[Axios] Network-level error:', {
        message: error.message,
        config: { method: error.config?.method, url: (error.config?.baseURL || '') + (error.config?.url || '') },
        timeout: error.config?.timeout,
      });
      return Promise.reject(new Error('Network Error（可能是 CORS/证书/超时/网络）'));
    }

    // 3) 有 response 的话，按你的业务格式处理
    const { status, data, headers } = error.response;
    // 处理HTTP状态码
    if (status == 401) {
      // token过期处理
      if (router.currentRoute.path !== '/signin') {
        try {
          await router.replace({
            path: '/signin',
            query: { redirect: router.currentRoute.fullPath }
          });
        } catch (navErr) {
          // 忽略重复导航等
          if (!(router.isNavigationFailure?.(navErr, 16))) {
            console.warn('router replace failed:', navErr);
          }
        }
      }
      // ✅ 关键：这里“结束链路”，不要再 reject
      return Promise.reject(error); // 或 return; 让调用方的 .then/.catch 不再收到错误
    }
    // 处理其他业务错误
    if (data && data.code !== 200 && data.code !== 0) {
      const errorMsg = data.message || 'Request failed'
      return Promise.reject(new Error(errorMsg))
    }
    console.error('[Axios] HTTP error:', status, (error.config?.url || ''), headers, data);

    // 兼容 data 为空的情况
    const msg = (data && (data.message || data.msg)) || `HTTP ${status}`;
    return Promise.reject(new Error(msg));
  }
)
shop.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.cache) {
      const source = CancelToken.source()
      config.cancelToken = source.token
      // 去缓存池获取缓存数据
      const key =
        config.method +
        config.baseURL +
        config.url +
        JSON.stringify(config.params)
      const data = cache[md5(key)]
      // 获取当前时间戳
      const expire_time = getExpireTime()
      if (data && expire_time - data.expire < EXPIRE_TIME) {
        source.cancel(data)
      }
    }
    let token = store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    console.log(token)
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    // do something with request error
    // for debug
    return Promise.reject(error)
  }
)

// response interceptor
shop.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      // Vue.prototype.$notify({
      //   title: 'ERROR',
      //   message: res.message || 'Error',
      //   type: 'warning',
      // })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
   async error => {
    // 1) 被我们用 cancelToken 命中缓存的情况
    if (axios.isCancel(error)) return Promise.resolve(error.message || error);

    // 2) 真正的网络层错误（CORS/证书/超时/DNS 等），没有 response
    if (!error.response) {
      // 常见触发：预检失败、HTTPS 页面请求 HTTP、证书异常、超时
      console.error('[Axios] Network-level error:', {
        message: error.message,
        config: { method: error.config?.method, url: (error.config?.baseURL || '') + (error.config?.url || '') },
        timeout: error.config?.timeout,
      });
      return Promise.reject(new Error('Network Error（可能是 CORS/证书/超时/网络）'));
    }

    // 3) 有 response 的话，按你的业务格式处理
    const { status, data, headers } = error.response;
    // 处理HTTP状态码
    if (status == 401) {
      // token过期处理
      if (router.currentRoute.path !== '/signin') {
        try {
          await router.replace({
            path: '/signin',
            query: { redirect: router.currentRoute.fullPath }
          });
        } catch (navErr) {
          // 忽略重复导航等
          if (!(router.isNavigationFailure?.(navErr, 16))) {
            console.warn('router replace failed:', navErr);
          }
        }
      }
      // ✅ 关键：这里“结束链路”，不要再 reject
      return Promise.reject(error); // 或 return; 让调用方的 .then/.catch 不再收到错误
    }
    // 处理其他业务错误
    if (data && data.code !== 200 && data.code !== 0) {
      const errorMsg = data.message || 'Request failed'
      return Promise.reject(new Error(errorMsg))
    }
    console.error('[Axios] HTTP error:', status, (error.config?.url || ''), headers, data);

    // 兼容 data 为空的情况
    const msg = (data && (data.message || data.msg)) || `HTTP ${status}`;
    return Promise.reject(new Error(msg));
  }
)


// 获取当前时间
promotion.interceptors.request.use(
  config => {
    const token = store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

promotion.interceptors.response.use(
  response => {
    const res = response.data
    if (!res || res.code !== 0) {
      const details = Array.isArray(res?.error) ? res.error.filter(Boolean) : []
      const message = [res?.message || 'Request failed', ...details].filter(Boolean).join(': ')
      const err = new Error(message)
      err.details = details
      err.payload = res
      return Promise.reject(err)
    }
    return res
  },
  async error => {
    if (!error.response) {
      return Promise.reject(new Error('Network Error'))
    }

    const { status, data } = error.response
    if (status === 401 && router.currentRoute.path !== '/signin') {
      try {
        await router.replace({
          path: '/signin',
          query: { redirect: router.currentRoute.fullPath }
        })
      } catch (_) {}
    }

    const details = Array.isArray(data?.error) ? data.error.filter(Boolean) : []
    const message = [data?.message || data?.msg || `HTTP ${status}`, ...details].filter(Boolean).join(': ')
    const err = new Error(message)
    err.details = details
    err.payload = data
    return Promise.reject(err)
  }
)

function getExpireTime() {
  return new Date().getTime()
}

export {
  streamer,
  viewer,
  shop,
  promotion
}
